<template>
  <div class="kk-page-404">
    <h1 class="kk-page-404__heading">
      404 Snakes!
      <br />
      Page not found
    </h1>
    <br />
    <button class="kk-page-404__btn">
      <router-link to="/designs" class="kk-page-404__btn--link"> Back to Designs </router-link>
    </button>
    <ul class="rectangles">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
  </div>
</template>

<style lang="less" scoped>
@import "../assets/styles/variables";

.kk-page-404 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: fixed;
  height: calc(100vh + 2rem);
  width: calc(100vw + 2rem);
  margin: -1rem;
  background-image: url("../assets/404.svg");
  background-size: cover;

  &__heading {
    color: white;
    font-size: 3.5rem;
    font-weight: 100;
    line-height: 1.25;
  }

  &__btn {
    padding: 0.5rem 2rem;
    border: 1px solid white;
    border-radius: 0.9rem;

    &:hover {
      color: @kk-color-primary-blue;
      background-color: @kk-color-gold;
      border: 1px solid @kk-color-gold;
    }

    &--link {
      color: white;
      text-decoration: none;

      &:hover {
        color: @kk-color-primary-blue;
      }
    }
  }
  .rectangles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    li {
      position: absolute;
      display: block;
      list-style: none;
      width: 20px;
      height: 5px;
      background: rgba(255, 255, 255, 0.2);
      animation: animate 25s linear infinite;
      bottom: -150px;

      &:nth-child(1) {
        left: 25%;
        width: 80px;
        height: 80px;
        animation-delay: 0s;
      }

      &::nth-child(2) {
        left: 10%;
        width: 20px;
        height: 20px;
        animation-delay: 2s;
        animation-duration: 12s;
      }

      &:nth-child(3) {
        left: 70%;
        width: 20px;
        height: 20px;
        animation-delay: 4s;
      }
      &:nth-child(4) {
        left: 40%;
        width: 60px;
        height: 60px;
        animation-delay: 0s;
        animation-duration: 18s;
      }

      &:nth-child(5) {
        left: 65%;
        width: 20px;
        height: 20px;
        animation-delay: 0s;
      }

      &:nth-child(6) {
        left: 75%;
        width: 110px;
        height: 110px;
        animation-delay: 3s;
      }
      &:nth-child(7) {
        left: 35%;
        width: 150px;
        height: 150px;
        animation-delay: 7s;
      }
      &:nth-child(8) {
        left: 50%;
        width: 25px;
        height: 25px;
        animation-delay: 15s;
        animation-duration: 45s;
      }

      &:nth-child(9) {
        left: 20%;
        width: 15px;
        height: 15px;
        animation-delay: 2s;
        animation-duration: 35s;
      }

      &:nth-child(10) {
        left: 85%;
        width: 150px;
        height: 150px;
        animation-delay: 0s;
        animation-duration: 11s;
      }
    }
  }
  @keyframes animate {
    0% {
      transform: translateY(0) rotate(0deg);
      opacity: 1;
      border-radius: 20%;
    }

    100% {
      transform: translateY(-1000px) rotate(720deg);
      opacity: 0;
      border-radius: 30%;
    }
  }
}
</style>
